module.exports = __webpack_public_path__ + "static/bentonsans-light-webfont-d955640b8d80fdcc35351b52d52e65f7.woff";